import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GridItemWithImage as GridItem } from '../../Global/Content/OffsetGrid'

const DruidsGlen = () => {
  const { image } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "druids-glen.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 630, maxHeight: 420) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <GridItem
      title="Druids Glen"
      description="Druid’s Glen is home to different parkland courses and is set in the heart of Ireland. The Mountains, Sea and rolling Irish Countryside provide stunning vistas throughout your round."
      sources={image.childImageSharp.fluid}
      imageAlt="Golf trips to Druids Glen with Chauffeur Me."
    />
  )
}

export default DruidsGlen